var _defs, _g, _rect, _rect2, _rect3, _rect4, _polygon;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSttLogo03(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 425.2 425.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b,.c,.d{fill:#fff;}.e{letter-spacing:.14em;}.c{font-family:GoudyOldStyleT-Bold, Goudy Old Style;font-size:47.75px;}.f{letter-spacing:.1em;}.g{letter-spacing:.06em;}.h{letter-spacing:.46em;}.i{letter-spacing:.48em;}.j{letter-spacing:.49em;}.k{letter-spacing:.1em;}.d{font-family:Montserrat-Medium, Montserrat;font-size:29.4px;}.l{letter-spacing:.5em;}.m{letter-spacing:.1em;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    className: "c",
    transform: "translate(15.43 380.47)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "e",
    x: 0,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    className: "f",
    x: 37.25,
    y: 0
  }, "WIN "), /*#__PURE__*/React.createElement("tspan", {
    className: "k",
    x: 168.45,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    className: "g",
    x: 203.74,
    y: 0
  }, "O"), /*#__PURE__*/React.createElement("tspan", {
    className: "m",
    x: 243.62,
    y: 0
  }, "WERS")), /*#__PURE__*/React.createElement("text", {
    className: "d",
    transform: "translate(76.14 334.88)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "l",
    x: 0,
    y: 0
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    className: "j",
    x: 33.17,
    y: 0
  }, "U"), /*#__PURE__*/React.createElement("tspan", {
    className: "l",
    x: 69.89,
    y: 0
  }, "JIM"), /*#__PURE__*/React.createElement("tspan", {
    className: "i",
    x: 165.59,
    y: 0
  }, "O"), /*#__PURE__*/React.createElement("tspan", {
    className: "h",
    x: 203.61,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    className: "l",
    x: 234.43,
    y: 0
  }, "O")))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 76.81,
    y: 32.32,
    width: 208.63,
    height: 12.37
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 177.43,
    y: 38.5,
    width: 12.37,
    height: 227.6
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 149.9,
    y: 83.92,
    width: 208.63,
    height: 12.37
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 245.55,
    y: 90.11,
    width: 12.37,
    height: 175.99
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "210.45 211.51 96.53 101.46 194.26 44 188 33.34 76.23 99.05 190.23 209.17 94.91 266.1 119.03 266.1 210.45 211.51"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSttLogo03);
export default __webpack_public_path__ + "static/media/STT-logo-03.1d176f3303976249b7d415b3057e0095.svg";
export { ForwardRef as ReactComponent };